import { render, staticRenderFns } from "./ExchangeCrypto.vue?vue&type=template&id=6bbd4ee2"
import script from "./ExchangeCrypto.vue?vue&type=script&lang=js"
export * from "./ExchangeCrypto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports